import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import MUITypography from '../../Components/MUITypography';
import { VM_Colors } from '../../Styles/VMStyles';

const CreatedByCell = ({ user }) => {
  if (!user) return <span>-</span>;

  const name = user.name || '-';
  const phone = ("+"+user.country_code+" "+user.mobile_no)  || '-';
  const email = user.email || '-';
  const userType = user.user_type || user.userType || '-';

  const tooltipContent = (
    <Box sx={{ p: 1 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 700 ,color:VM_Colors.white}}>{name}</Typography>
      <Typography variant="caption">Phone: {phone}</Typography>
      <br />
      <Typography variant="caption">Email: {email}</Typography>
      <br />
      <Typography variant="caption">Role: {userType}</Typography>
    </Box>
  );

  return (
    <Tooltip title={tooltipContent} placement="top" arrow>
      <Box sx={{ cursor: 'pointer', minWidth: 0, maxWidth: '100%' }}> 
        <MUITypography
          variant="body2"
          sx={{
            fontSize: 'inherit',
            lineHeight: 1.35,
            fontWeight: 400,
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          }}
        >
          {name}
        </MUITypography>
      </Box>
    </Tooltip>
  );
};

export default CreatedByCell;
